import axiosPost from "../axiosPost";

const SERVICIOS_ORDER = ["IDBASE", "LBM", "HGATE", "SIGN"];

export const loginServicioGet = async ({
    merchantId,
}, credentials) => {
    const body = {
        service: "MIAServicioGet",
        params: {
            merchantId: credentials.merchantId ?? merchantId,
        },
    };

    const response = await axiosPost(body, credentials);

    if (response?.result) {
        response.result = [...response.result].sort((a, b) => {
            const indexA = SERVICIOS_ORDER.indexOf(a.servicioCod);
            const indexB = SERVICIOS_ORDER.indexOf(b.servicioCod);
            if (indexA === -1 && indexB === -1) return 0;
            if (indexA === -1) return 1;
            if (indexB === -1) return -1;
            return indexA - indexB;
        });
    }

    return response;
};
